import React from 'react';
interface MultiSelectChipsProps {
  options: {
    value: string;
    label: string;
  }[];
  values: string[];
  onChange: (values: string[]) => void;
  exclusive?: boolean;
}
export function MultiSelectChips({
  options,
  values,
  onChange,
  exclusive = false
}: MultiSelectChipsProps) {
  const toggle = (val: string) => {
    if (exclusive) {
      onChange([val]);
      return;
    }
    if (values.includes(val)) {
      onChange(values.filter(v => v !== val));
    } else {
      onChange([...values, val]);
    }
  };
  return <div className="flex flex-wrap gap-2" role="group" data-id="element-14">
      {options.map(opt => {
      const isSelected = values.includes(opt.value);
      return <button key={opt.value} type="button" aria-pressed={isSelected} onClick={() => toggle(opt.value)} className={`px-4 py-2 rounded-full text-sm font-medium transition-all border ${isSelected ? 'bg-blue-50 border-blue-600 text-blue-700 shadow-sm' : 'bg-white border-gray-200 text-gray-700 hover:border-blue-300 hover:bg-gray-50'}`} data-id="element-15">
            {opt.label}
          </button>;
    })}
    </div>;
}